import React, { FC } from 'react';
import './style.scss';
import { AppBar, Toolbar } from "@material-ui/core";
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../redux';
import Logo from "../../assets/images/logo.png";

interface IHeader {
    backLink: string
    title?: string
    filterButton?: string
}

const Header: FC<IHeader> = ({  backLink, filterButton }) => {

    const { type } = useSelector(({payment}: ApplicationState) => payment)
    let title;

    switch (type) {
        case 1:
            title = "شارژ مستقیم";
            break;
        case 0:
            title = "اینترنت";
            break;
        default:
            break;
    }

    return (
      <AppBar position="static">
        <Toolbar>
          {/* {title && title} */}
          <img src={Logo} style={{ height: "32px", width: "auto"}}/>
        </Toolbar>
      </AppBar>
    );
}
export default Header
